<template>
  <div class="SwitchImg"
    v-on:mouseover="hover = true"
    v-on:mouseout="hover = false">
    <img :src="imgOn" v-if="hover" />
    <img :src="imgOff" v-else />
    <div :class="{ whiteText: hover }">{{ inputName }}</div>
  </div>
</template>

<script>

export default {
  name: 'SwitchImg',
  data () {
    return {
      hover: false,
      imgOn: null,
      imgOff: null
    }
  },
  props: {
    inputName: {
      type: String,
      required: true,
      default: 'Gallery'
    },

    imageOn: {
      type: String,
      require: false,
      default: ''
    },

    imageOff: {
      type: String,
      require: false,
      default: ''
    }
  },

  mounted () {
    this.imgOn = this.imageOn !== '' ? this.imageOn : require('../assets/Image/btn_demo_on.png')
    this.imgOff = this.imageOff !== '' ? this.imageOff : require('../assets/Image/btn_demo_off.png')
  }
}
</script>

<style lang="scss" scoped>
.SwitchImg{
  position: relative;
  div {
    position: absolute;
    top: 65%;
    width: 100%;
    left: 0;
    padding-left: 3px;
    padding-right: 3px;
    text-align: center;
    white-space: nowrap;
    text-overflow : ellipsis;
    overflow : hidden;
    color: rgb(148, 195, 207);
  }
}
.whiteText {
  color: white !important;
}
img {
  width: 100%;
}
</style>
